import React from 'react';
import LiteraryAssociation2024 from 'views/LiteraryAssociation2024';

const BlogNewsroomPage = () => {

return <LiteraryAssociation2024/>
};

export default BlogNewsroomPage;